<template>
  <div class="grid grid-cols-9 m-4 mb-8">
    <!-- TODO: ユーザID検索機能の追加 -->
    <!-- <input
            type="search"
            v-model="form.userId"
            class="col-span-3 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
            placeholder="ユーザID"
            /> -->
    <input
      v-model="form.studentId"
      type="search"
      class="col-span-2 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
      placeholder="学籍番号" />
    <select
      v-model="form.serviceYears"
      class="col-span-1 ml-2 border border-gray-300 outline-none rounded-md py-2 px-3 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none">
      <option
        v-for="(serviceYear, i) in SCHOOL_RESULT_SERVICE_YEARS"
        :key="i"
        :value="i === 0 ? '' : i">
        {{ serviceYear }}
      </option>
    </select>
    <input
      v-model="form.nameKeyword"
      type="search"
      class="col-span-3 ml-4 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
      placeholder="名前" />
    <button
      class="col-span-1 relative ml-8 px-6 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
      @click.prevent="onSearchButtonClicked">
      <svg
        class="absolute pointer-events-none w-6 h-6 top-1/4 left-1/4 text-white"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24">
        <path
          d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
      </svg>
    </button>
    <button
      class="col-span-2 bg-white hover:bg-gray-100 text-black ml-4 py-2 px-1 border border-gray-200 rounded shadow"
      @click.prevent="onResetButtonClicked">
      リセット
    </button>
  </div>
  <template v-if="!users.data.length">
    <div
      class="mx-auto w-11/12 bg-red-100 border border-red-400 text-red-500 px-4 py-3 mt-8 rounded relative text-center"
      role="alert">
      <span class="block sm:inline font-bold">ユーザーが見つかりませんでした。</span>
    </div>
  </template>
  <template v-else>
    <div class="grid grid-cols-3 py-2 text-gray-600">
      <div class="col-span-3">
        PerPage:
        <select
          :value="paginatePerPage"
          class="ml-2 pl-2 rounded border-gray-400"
          @change="onChangedPerPage">
          <option
            v-for="(n, i) in paginatePerPages"
            :key="i">
            {{ n }}
          </option>
        </select>
      </div>
    </div>
    <div class="shadow-lg bg-white mr-1 rounded-b-lg rounded-t px-4 py-5">
      <template v-if="users.data.length">
        <data-table
          drag-disabled
          :sort="sort"
          :order="order"
          :headers="headers"
          :items="users.data"
          @row-click="onClickRow"
          @header-click="onClickHeader">
          <template #user_id="{ item }">
            <div class="text-left px-6">
              {{ item.client_id ?? '-' }}
            </div>
          </template>
          <template #student_id="{ item }">
            <div class="text-left px-6">
              {{ item.student_id ?? '-' }}
            </div>
          </template>
          <template #service_years="{ item }">
            <div class="text-center px-6">
              {{ convertToGrade(item.service_years) }}
            </div>
          </template>
          <template #name="{ item }">
            <div
              class="text-left px-6"
              style="width: 150px">
              {{ item.name ?? '-' }}
            </div>
          </template>
          <template #school_ranking="{ item }">
            <div
              class="text-left px-6"
              style="width: 150px">
              {{ item.school_ranking ?? '-' }}
            </div>
          </template>
          <template #ranking="{ item }">
            <div
              class="text-left px-6"
              style="width: 150px">
              {{ getRanking(item.client_id) }}
            </div>
          </template>
          <template #compulsory="{ item }">
            <div class="text-center px-6">
              {{ item.compulsory ?? '-' }}
            </div>
          </template>
          <template #general="{ item }">
            <div class="text-center px-6">
              {{ item.general ?? '-' }}
            </div>
          </template>
          <template #practice="{ item }">
            <div class="text-center px-6">
              {{ item.practice ?? '-' }}
            </div>
          </template>
          <template #total="{ item }">
            <div class="text-center px-6">
              {{ item.total }}
            </div>
          </template>
        </data-table>
        <div
          v-if="users.total > paginatePerPage"
          class="mb-5">
          <div class="mt-4">
            <pagination
              :paginate="users"
              @page-previous="onPaginationChanged"
              @page-next="onPaginationChanged"
              @page-click="onPaginationChanged" />
          </div>
        </div>
      </template>
    </div>
  </template>
</template>

<script setup>
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'
import {
  reactive, ref, onMounted, computed,
} from 'vue'
import DownloadCsv from 'vue-json-csv'
import DataTable from '@/Common/DataTable'
import Pagination from '../../../Common/Pagination'
import convertToGrade from '@/actions/serviceYears/convert'
import AppClientSchoolLayout from '@/Layouts/AppClientSchoolLayout'
import { SCHOOL_RESULT_SERVICE_YEARS } from '@/Constants/serviceYears'

const props = defineProps({
  users: {
    type: Object,
    default: () => ({}),
  },
  selectedExamination: {
    type: Object,
    default: () => ({}),
  },
  limit: {
    type: String,
    default: '15',
  },
  sort: {
    type: String,
    default: 'id',
  },
  order: {
    type: String,
    default: 'asc',
  },
  userId: {
    type: String,
    default: null,
  },
  studentId: {
    type: String,
    default: null,
  },
  serviceYears: {
    type: String,
    default: null,
  },
  nameKeyword: {
    type: String,
    default: null,
  },
  rankings: {
    type: Array,
    default: () => [],
  },
})

const paginatePerPage = ref('15')
const paginatePerPages = ['5', '10', '15', '30', '50', '100', 'ALL']

const headers = {
  user_id: 'ユーザID',
  student_id: '学籍番号',
  service_years: '学年',
  name: '名前',
  school_ranking: '校内順位',
  ranking: '全国順位',
  compulsory: '必須(Max:50)',
  general: '一般(Max:100)',
  practice: '実地(Max:50)',
  total: '合計(Max:200)',
}

const form = reactive(Inertia.form({
  userId: props.userId,
  studentId: props.studentId,
  serviceYears: props.serviceYears,
  nameKeyword: props.nameKeyword,
}))

onMounted(() => {
  if (props.limit === '0') {
    paginatePerPage.value = 'ALL'
  } else {
    paginatePerPage.value = props.users.per_page
  }
})

const onSearchButtonClicked = () => {
  Inertia.get(route('school.result', {
    sort: props.sort,
    order: props.order,
    examinationId: props.selectedExamination.id,
    userId: form.userId,
    studentId: form.studentId,
    serviceYears: form.serviceYears,
    nameKeyword: form.nameKeyword,
    limit: props.limit,
  }))
}

const onResetButtonClicked = () => {
  form.userId = ''
  form.studentId = ''
  form.serviceYears = ''
  form.nameKeyword = ''
  Inertia.get(route('school.result', {
    sort: props.sort,
    order: props.order,
    examinationId: props.selectedExamination.id,
    userId: form.userId,
    studentId: form.studentId,
    serviceYears: form.serviceYears,
    nameKeyword: form.nameKeyword,
    limit: props.limit,
  }))
}

const onClickHeader = (key) => {
  let { order } = props
  if (props.sort === key) {
    order = order === 'asc' ? 'desc' : 'asc'
  } else {
    order = 'asc'
  }
  Inertia.get(route('school.result', {
    limit: props.limit,
    sort: key,
    order,
    userId: props.userId,
    examinationId: props.selectedExamination.id,
    studentId: props.studentId,
    serviceYears: props.serviceYears,
    nameKeyword: props.nameKeyword,
  }))
}

const onPaginationChanged = (page) => {
  Inertia.get(route('school.result', {
    page,
    limit: props.limit,
    sort: props.sort,
    order: props.order,
    examinationId: props.selectedExamination.id,
    userId: props.userId,
    studentId: props.studentId,
    serviceYears: props.serviceYears,
    nameKeyword: props.nameKeyword,
  }))
}

const onChangedPerPage = (e) => {
  Inertia.get(route('school.result', {
    page: '1',
    limit: e.target.value === 'ALL' ? '0' : e.target.value,
    sort: props.sort,
    order: props.order,
    examinationId: props.selectedExamination.id,
    userId: props.userId,
    studentId: props.studentId,
    serviceYears: props.serviceYears,
    nameKeyword: props.nameKeyword,
  }, {
    only: ['users'],
  }))
}

const getRanking = (userId) => {
  const ranking = props.rankings.find(value => value.user_id === userId)

  return ranking ? ranking.ranking : '-'
}

const onClickRow = (item) => {
  Inertia.get(route('school.studentResult.show', {
    userId: item.id,
    examinationId: props.selectedExamination.id,
  }))
}
</script>

<style></style>
